import { render, staticRenderFns } from "./DniFieldCreateBusiness.vue?vue&type=template&id=384d0d68&"
import script from "./DniFieldCreateBusiness.vue?vue&type=script&lang=ts&"
export * from "./DniFieldCreateBusiness.vue?vue&type=script&lang=ts&"
import style0 from "./DniFieldCreateBusiness.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports